import styled from "styled-components";
import { PrimaryButtonComponent } from "../../../../CommonComponents/commonStyles";
import { NoChangeSpace } from "../Step1Setup/styles";

export const StepHead = styled.div`
  font-family: BerkeleyStd-Book;
  font-size: 24px;
  font-weight: normal;
  line-height: 1.13;
  color: #022737;
  margin-bottom: 10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 8px;
  }
`;

export const MiniContent = styled.span`
  font-family: HelveticaNeue;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.25;
  letter-spacing: 0.6px;
  color: #505050;
  margin-bottom: 10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    line-height: 1.43;
    letter-spacing: 0.5px;
  }
`;

export const SelectWrap = styled.div`
  width: 300px;
  margin-top: -14px;
  padding-bottom: 26px;
  .ant-select-dropdown {
    top: 44px !important;
    width: 100% !important;
    box-shadow: none;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    padding-bottom: 16px;
  }
`;

export const PrimaryButton = styled(PrimaryButtonComponent)`
  width: auto;
  color: #ffffff;
  //font-family: HelveticaNeue-CondensedBlack;
  font-size: 18px;
  line-height: 1.67;
  letter-spacing: 1.1px;
  text-align: center;
  color: #ffffff;
  border: none;
  border-radius: 0;
  min-width: 150px;
  display: inline-block;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 18px !important;
    margin-bottom: 20px;
  }
`;

export const LinkStyle = styled(NoChangeSpace)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 12px;
    line-height: 1.17;
    letter-spacing: 0.5px;
    width: 140px;
  }
`;

export const UnderLine = styled.span`
  color: #006778;
  text-decoration: underline;
  cursor: pointer;
`;

export const StepSubHead = styled.div`
  width: ${props => props.contentWidth};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: ${props => props.mWidth};
  }
`;
